import { startSubmit, stopSubmit } from 'redux-form';
import { fetchAction } from 'barnyard/utils/';
import * as types from '../constants';

export const buyerFetchFormFields = () => dispatch => fetchAction(
  dispatch,
  types.BUYER_FETCH_FORM_FIELDS,
  {},
  { url: '/api/buyers/buyer/fields/' }
);

const buyerUpdateAction = formName => values => dispatch => fetchAction(
  dispatch,
  types.BUYER_UPDATE,
  {},
  {
    url: '/api/buyers/buyer/',
    method: 'PATCH',
    body: values,
    postBefore: () => {
      dispatch(startSubmit(formName));
    },
    postSuccess: () => {
      dispatch(stopSubmit(formName));
    },
    postFailure: (error) => {
      dispatch(stopSubmit(formName, {
        _error: {
          title: error.detail || 'Error Updating Information',
          details: `
Please correct the form and try again.
If this issue continues, contact us via the chat icon in the bottom right.`
        },
        ...error
      }));
    }
  }
);

export const buyerUpdate = buyerUpdateAction(types.BUYER_UPDATE_FORM);

export const buyerVendorsUpdate = buyerUpdateAction(types.VENDOR_UPDATE_FORM);
